<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-3">
               &nbsp;
               &nbsp;
            </div>
            <div class="col-sm-6">
               Powered by <img src="assets/images/zillion.png" alt="" height="50">
               &nbsp;
            </div>
            <div class="col-sm-3">
                <div class="text-sm-end d-none d-sm-block">
                    &nbsp;
                    &nbsp;
                </div>
            </div>
        </div>
    </div>
</footer>